import { Outlet } from 'react-router-dom'
import React from 'react'

const Message = () => {
  return (
    <Outlet/>
  )
}

export default Message